const LinkedIn = () => (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path fillRule="evenodd" clipRule="evenodd" d="M6.806 4.407a2.407 2.407 0 0 1-2.402 2.408A2.406 2.406 0 0 1 2 4.407 2.405 2.405 0 0 1 4.404 2a2.406 2.406 0 0 1 2.402 2.407zm6.41 10.984c0-1.742.33-3.43 2.488-3.43 2.125 0 2.154 1.993 2.154 3.543V22h4.141v-7.328c0-3.597-.775-6.363-4.972-6.363-2.016 0-3.368 1.107-3.921 2.157h-.056V8.641H9.074v13.36h4.142v-6.61zm-6.741-6.75H2.33V22h4.145V8.64z" fill="#000" />
    </svg>
)

export default LinkedIn;